module.exports = ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 59
// module chunks = 0